<template>
  <div class="mine-main">
    <router-view />
    <Bottom />
  </div>
</template>

<script>
import Bottom from "@/components/home/BottomBar.vue";
export default {
  components: {
    Bottom
  }
};
</script>

<style lang="scss" scoped>
.mine-main {
  height: 100vh;
  width: 100%;
  max-width: 10rem;
}
</style>
